// extracted by mini-css-extract-plugin
var _1 = "TeamUpgradeInfo-module__animateUploadProgressBarWidth--ryySo";
var _2 = "TeamUpgradeInfo-module__animatedBackground--lx7vQ";
var _3 = "TeamUpgradeInfo-module__progressContainer--Rx1j1";
var _4 = "TeamUpgradeInfo-module__trialInfo--N8pLS";
var _5 = "TeamUpgradeInfo-module__upgradeButton--Zj9Jn";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "progressContainer", _4 as "trialInfo", _5 as "upgradeButton" }
